import ai from '../../assets/images/portfolio/ai.jpeg';
import data from '../../assets/images/portfolio/data.jpg';
import business from '../../assets/images/portfolio/business.jpg';
import automation from '../../assets/images/portfolio/automation.jpg';
import marketing from '../../assets/images/portfolio/marketing.jpg';
import website from '../../assets/images/portfolio/website.jpg';

const PortfolioData = [
  {
    "id": 1,
    "img": business,
    "subtitle": "International Gateways",
    "subcontent": "",
  },
  {
    "id": 2,
    "img": ai,
    "subtitle": "Enterprise Solutions",
    "subcontent": "",
  },
  {
    "id": 3,
    "img": data,
    "subtitle": "Digital Service Delivery Platform",
    "subcontent": "",
  },
  {
    "id": 4,
    "img": automation,
    "subtitle": "Central Bank Exchanges",
    "subcontent": "",
  },
  {
    "id": 5,
    "img": marketing,
    "subtitle": "Mobile Money Payments",
    "subcontent": "",
  },
  {
    "id": 6,
    "img": website,
    "subtitle": "Country Identity & Secure Technologies",
    "subcontent": "",
  },
]

export default PortfolioData